export default __webpack_public_path__ + "static/media/wrench.d0a1b7e0.svg";